var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.parkingCode") } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text", disabled: true },
                model: {
                  value: _vm.childData.parkingCode,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "parkingCode", $$v)
                  },
                  expression: "childData.parkingCode"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.parkingOwner") } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-item-width",
                  attrs: {
                    filterable: "",
                    clearable: "",
                    loading: _vm.loading,
                    placeholder: "请输入(业主姓名/电话号码)"
                  },
                  model: {
                    value: _vm.childData.customerId,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "customerId", $$v)
                    },
                    expression: "childData.customerId"
                  }
                },
                _vm._l(_vm.customerList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.customerName, value: item.customerId }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handBindingCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handUpdate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }